(() => {
  const selector = '[data-darino-wall-consent]';
  function block(form, event) {
    const input = form && form.querySelector(selector);
    if (!input || input.checked) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    input.focus();
    input.reportValidity();
  }
  document.addEventListener('submit', event => block(event.target, event), true);
  document.addEventListener('click', event => {
    const button = event.target.closest('button[name="add"],input[name="add"]');
    if (button) block(button.form, event);
  }, true);
})();